(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-date-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-date-picker')) {
    customElements.define(
      'delivery-date-picker',
      class DeliveryDatePicker extends HTMLElement {
        static citiesPromise = null;

        connectedCallback() {
          this.prefecture = this.querySelector('[data-delivery-prefecture]');
          this.city = this.querySelector('[data-delivery-city]');
          this.date = this.querySelector('[data-delivery-date]');
          this.time = this.querySelector('[data-delivery-time]');
          this.cityField = this.querySelector('[data-city-field]');
          this.dateField = this.querySelector('[data-date-field]');
          this.timeField = this.querySelector('[data-time-field]');
          this.status = this.querySelector('[data-delivery-status]');
          this.config = JSON.parse(this.querySelector('[data-delivery-config]').textContent);
          this.checkout = document.getElementById('checkout');
          this.slots = new Map();
          this.saveQueue = Promise.resolve();
          this.abortController = null;
          this.savedDate = this.date.value;
          this.savedTime = this.time.value;
          this.hasLoadedDestination = false;

          this.prefecture.addEventListener('change', () => this.prefectureChanged());
          this.city.addEventListener('change', () => this.destinationChanged());
          this.date.addEventListener('change', () => this.dateChanged());
          this.time.addEventListener('change', () => this.saveAttributes());

        }

        disconnectedCallback() {
          this.abortController?.abort();
        }

        async prefectureChanged() {
          this.replaceOptions(this.city, this.config.cityPlaceholder);
          this.city.disabled = true;
          this.cityField.hidden = !this.prefecture.value;
          this.destinationChanged();

          if (this.prefecture.value) {
            await this.loadCities();
          }
        }

        async loadCities() {
          this.city.disabled = true;
          this.setStatus(this.config.loadingCities);

          try {
            const cities = await this.fetchCities(this.prefecture.value);
            this.replaceOptions(this.city, this.config.cityPlaceholder);
            cities.forEach((cityName) => this.city.add(new Option(cityName, cityName)));
            this.city.disabled = cities.length === 0;

            if (cities.length === 0) {
              this.setStatus(this.config.citiesError, true);
              this.dateField.hidden = true;
              this.timeField.hidden = true;
              return;
            }

            this.setStatus('');
            this.dateField.hidden = true;
            this.timeField.hidden = true;
          } catch (error) {
            this.city.disabled = true;
            this.setStatus(this.config.citiesError, true);
            this.dateField.hidden = true;
            this.timeField.hidden = true;
          }
        }

        async fetchCities(prefecture) {
          if (!DeliveryDatePicker.citiesPromise) {
            DeliveryDatePicker.citiesPromise = fetch(this.config.citiesApiUrl, {
              method: 'GET',
              headers: { Accept: 'application/json' },
            }).then((response) => {
              if (!response.ok) throw new Error(`HTTP ${response.status}`);
              return response.json();
            });
          }

          try {
            const allCities = await DeliveryDatePicker.citiesPromise;
            return allCities[prefecture] || [];
          } catch (error) {
            DeliveryDatePicker.citiesPromise = null;
            throw error;
          }
        }

        destinationChanged() {
          const restoreSelection = !this.hasLoadedDestination;
          if (!restoreSelection) {
            this.savedDate = '';
            this.savedTime = '';
          }
          this.replaceOptions(this.date, this.config.datePlaceholder);
          this.replaceOptions(this.time, this.config.timePlaceholder);
          this.date.disabled = true;
          this.time.disabled = true;
          if (!restoreSelection) this.saveAttributes();

          const showDateTime = Boolean(this.prefecture.value && this.city.value.trim());
          this.dateField.hidden = !showDateTime;
          this.timeField.hidden = !showDateTime;

          if (showDateTime) {
            this.loadSlots(restoreSelection);
          } else {
            this.abortController?.abort();
            this.setLoading(false);
            this.setStatus('');
          }
        }

        async loadSlots(restoreSelection) {
          this.abortController?.abort();
          this.abortController = new AbortController();
          const request = this.abortController;
          this.setLoading(true);
          this.setStatus(this.config.loading);

          const url = `${this.config.apiBase}${encodeURIComponent(this.prefecture.value)}/${encodeURIComponent(
            this.city.value.trim()
          )}`;

          try {
            const response = await fetch(url, { method: 'GET', headers: { Accept: 'application/json' }, signal: request.signal });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const payload = await response.json();
            if (!Array.isArray(payload)) throw new Error('Invalid response');

            const validTimes = new Set(Object.keys(this.config.times));
            const slots = payload
              .filter((slot) => slot && /^\d{4}-\d{2}-\d{2}$/.test(slot.date) && Array.isArray(slot.times))
              .map((slot) => ({ date: slot.date, times: slot.times.filter((value) => validTimes.has(value)) }))
              .filter((slot) => slot.times.length > 0);

            this.slots = new Map(slots.map((slot) => [slot.date, slot.times]));
            this.replaceOptions(this.date, this.config.datePlaceholder);

            slots.forEach((slot) => {
              const option = new Option(this.formatDate(slot.date), slot.date);
              this.date.add(option);
            });

            this.date.disabled = slots.length === 0;
            if (restoreSelection && this.slots.has(this.savedDate)) {
              this.date.value = this.savedDate;
            }
            this.populateTimes(restoreSelection ? this.savedTime : '');
            this.hasLoadedDestination = true;
            if (restoreSelection && (this.date.value !== this.savedDate || this.time.value !== this.savedTime)) {
              this.saveAttributes();
            }

            if (slots.length === 0) {
              this.setStatus(this.config.noDates, true);
            } else {
              this.setStatus('');
            }
          } catch (error) {
            if (error.name === 'AbortError') return;
            this.replaceOptions(this.date, this.config.datePlaceholder);
            this.replaceOptions(this.time, this.config.timePlaceholder);
            this.date.disabled = true;
            this.time.disabled = true;
            this.setStatus(this.config.fetchError, true);
          } finally {
            if (this.abortController === request) this.setLoading(false);
          }
        }

        dateChanged() {
          this.populateTimes(this.time.value);
          this.saveAttributes();
        }

        populateTimes(selectedTime) {
          this.replaceOptions(this.time, this.config.timePlaceholder);
          const times = this.availableTimes();
          times.forEach((value) => this.time.add(new Option(this.config.times[value], value)));
          this.time.disabled = times.length === 0;
          if (times.includes(selectedTime)) this.time.value = selectedTime;
        }

        availableTimes() {
          if (this.date.value) return this.slots.get(this.date.value) || [];
          const available = new Set(Array.from(this.slots.values()).flat());
          return Object.keys(this.config.times).filter((value) => available.has(value));
        }

        replaceOptions(select, placeholder) {
          select.replaceChildren(new Option(placeholder, ''));
        }

        formatDate(value) {
          const date = new Date(`${value}T00:00:00+09:00`);
          return new Intl.DateTimeFormat(document.documentElement.lang || 'ja', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'short',
            timeZone: 'Asia/Tokyo',
          }).format(date);
        }

        setLoading(isLoading) {
          this.setAttribute('aria-busy', String(isLoading));
          if (this.checkout) this.checkout.disabled = isLoading;
        }

        setStatus(message, isError = false) {
          this.status.textContent = message;
          this.status.dataset.error = String(isError);
        }

        saveAttributes() {
          const attributes = {
            '配送希望日': this.date.value,
            '配送希望時間帯': this.time.value,
          };

          this.saveQueue = this.saveQueue
            .catch(() => undefined)
            .then(async () => {
              const root = window.Shopify?.routes?.root || '/';
              const response = await fetch(`${root}cart/update.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ attributes }),
              });
              if (!response.ok) throw new Error(`HTTP ${response.status}`);
            })
            .catch(() => this.setStatus(this.config.saveError, true));

          return this.saveQueue;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
